export const styles = {
  wrapper: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    overflow: "hidden",
    zIndex: 9999,
    backgroundColor: "#17171770"
  },
  container: {
    position: "fixed",
    top: 0,
    right: 0,
    bottom: 0,
    height: "100dvh",
    background: "white",
    zIndex: 9999
  }
};
